<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>Payment Gateways</h2>
                </div>
                <div class="col-md-2 col2 ">
                    <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img
                                src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                                alt=""> </button> </a>
                </div>

                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">
                    <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/tScYv5RleU8"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-md-12 mt-3">
                    <label for="" class="spm">A payment gateway is a technology that
                        facilitates the
                        secure and efficient transfer of payment information between a website,
                        mobile application, or point-of-sale system and a bank or financial
                        institution. It acts as a bridge between the merchant (seller) and the
                        payment processor or acquiring bank, ensuring that the customer's payment
                        details are encrypted and transmitted securely. </label>


                </div>
                <div class="col-md-12 mt-3">
                    <label for="" class="spm">The main purpose of a payment gateway
                        is to authorize
                        and process payment transactions in a way that is both secure and seamless.
                    </label>

                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">
                    <h3>
                        Here's how a payment gateway typically works:
                    </h3>

                    <label class="mt-4 spn"><b>Customer initiates a
                            transaction:</b>&nbsp; When a
                        customer makes
                        a purchase on an e-commerce website or mobile app, they enter their payment
                        information
                        (credit card details, bank account information, etc.) during the checkout
                        process.
                    </label>
                    <label class="mt-4 spn"><b>Data encryption: </b>&nbsp;The
                        payment gateway
                        encrypts
                        the
                        customer's payment data to ensure its security during transmission. This
                        encryption
                        helps protect sensitive information from unauthorized access or
                        theft.</label>

                    <label class="mt-4 spn"><b>Transmission to the acquiring
                            bank:</b>&nbsp; The
                        encrypted
                        payment data is transmitted to the acquiring bank or payment processor. The
                        acquiring
                        bank is responsible for validating the transaction and checking if the
                        customer
                        has
                        sufficient funds or credit available to complete the purchase. </label>
                    <label class="mt-4 spn"><b> Authorization:</b>&nbsp; The
                        acquiring bank sends an
                        authorization request to the customer's issuing bank (the bank that issued
                        the
                        credit
                        card or account being used for the payment). The issuing bank verifies the
                        transaction
                        and checks for fraud or any other issues. If approved, it sends an
                        authorization
                        code
                        back to the acquiring bank. </label>
                    <label class="mt-4 spn"><b> Transaction approval or
                            decline:</b>&nbsp; Based on
                        the
                        response
                        from the issuing bank, the acquiring bank or payment processor communicates
                        to
                        the
                        payment gateway whether the transaction is approved or declined. </label>
                    <label class="mt-4 spn"><b>Customer notification:</b>&nbsp; The
                        customer
                        receives
                        immediate
                        feedback on the transaction's status. If approved, they will see
                        confirmation of
                        their
                        purchase. If declined, they may be asked to try another payment method.
                    </label>
                    <label class="mt-4 spn"><b>Settlement:</b>&nbsp; Once the
                        transaction is
                        approved,
                        the funds
                        are transferred from the customer's account to the Distributor's account,
                        typically
                        through
                        the banking system. </label>
                    <label class="mt-4 spn">Payment gateways are essential for
                        online businesses as
                        they
                        provide
                        a secure and efficient way to accept payments. They help protect sensitive
                        customer
                        data, reduce the risk of fraud, and streamline the payment process.</label>



                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">
                    <h3>Where can a payment gateway be used? </h3>
                    <label for="" class="spn mt-3">A payment gateway is a technology
                        used in various
                        contexts to facilitate electronic transactions, particularly online
                        payments.
                        Here are some common scenarios and places where payment gateways are used:
                    </label>

                    <div class="mt-3 p-1 " style="margin-left: 10%;">
                        <ul class="p-1 ">
                            <li *ngFor="let prs of process">{{prs}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="4">
                    <h3>
                        How does a payment gateway contribute to the betterment of our society?
                    </h3>
                    <label for="" class="spn mt-3">A payment gateway offers several
                        benefits to
                        society
                        by facilitating secure, convenient, and efficient electronic transactions.
                        Here
                        are some ways in which payment gateways contribute to the betterment of
                        society</label>
                    <label class="mt-4 spn"><b> Financial Inclusion:</b>&nbsp;
                        Payment gateways help
                        bridge the
                        gap in financial inclusion by providing individuals, especially in remote or
                        underserved
                        areas, with the ability to participate in the digital economy </label>
                    <label class="mt-4 spn"><b> Convenience and
                            Efficiency:</b>&nbsp; Payment
                        gateways
                        streamline the payment process, making transactions quick and convenient.
                        This
                        efficiency is particularly valuable in a fast-paced society where time is of
                        the
                        essence. </label>
                    <label class="mt-4 spn"><b> Global Commerce:</b>&nbsp; Payment
                        gateways
                        facilitate
                        cross-border transactions, fostering global commerce. Businesses can reach
                        customers
                        worldwide, and consumers can access products and services from different
                        regions.
                    </label>
                    <label class="mt-4 spn"><b> Economic Growth:</b>&nbsp; By
                        enabling online
                        commerce,
                        payment
                        gateways contribute to economic growth. Businesses, especially small and
                        medium
                        enterprises (SMEs), can expand their customer base and increase sales,
                        driving
                        economic
                        development. </label>
                    <label class="mt-4 spn"><b> Reduction in Cash
                            Handling:</b>&nbsp; The use of
                        payment
                        gateways reduces the reliance on cash transactions, leading to a decrease in
                        associated
                        risks. </label>
                    <label class="mt-4 spn"><b> Transparency and
                            Accountability:</b>&nbsp;
                        Electronic
                        transactions through payment gateways leave a digital trail, enhancing
                        transparency and
                        accountability. This can be beneficial in various sectors, including
                        government,
                        finance, and charitable organizations. </label>

                    <label class="mt-4 spn"><b> Charitable Contributions:
                        </b>&nbsp;Charities and
                        nonprofit
                        organizations leverage payment gateways to collect online donations
                        efficiently.
                        This
                        makes it easier for people to contribute to social causes, disaster relief
                        efforts, and
                        community development projects. </label>
                    <label class="mt-4 spn"><b> Educational Access:</b>&nbsp;
                        Educational
                        institutions
                        use
                        payment gateways to facilitate online payments for tuition, fees, and other
                        educational
                        expenses. This enhances accessibility to education and simplifies financial
                        transactions
                        for students and parents. </label>
                    <label class="mt-4 spn"><b> Healthcare Services:</b>&nbsp;
                        Payment gateways in
                        the
                        healthcare sector contribute to the ease of transactions related to medical
                        services,
                        insurance payments, and online pharmacy purchases. </label>
                    <label for="" class="mt-4 spn"> <b>Consumer
                            Empowerment:</b>&nbsp; Payment
                        gateways
                        empower
                        consumers by providing them with secure and convenient payment options.
                        This, in
                        turn,
                        enhances the overall consumer experience.</label>

                </div>
            </div>

        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <a href="#1">
                        <div class="row">
                            <div class="col-md-2 "> <img src="./assets/video.svg" class="tab-icon intro" alt=""> &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;" [ngClass]="{'video':colors=='1'}"
                                    (click)="color('1')">
                                    Introduction to
                                    Payment Gateways
                                </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;
                            </div>
                            <div class="col-md-10 ">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')"> How
                                    Payment
                                    Gateway Works? </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    Where it can be
                                    used? </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">Benefits
                                    of
                                    Payment Gateway. </span>

                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9 ">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" >
                <a [routerLink]="['/features']"> <button class="btn btn-color"> <img src="./assets/Arrow 3.svg"
                            alt="">&nbsp;&nbsp;PayG feature
                    </button></a>

            </div>
            <div class="col-md-4">
                <a [routerLink]="['/payment-gateway-working']"><button class="btn btn-color "
                        (click)="menues('PayG')">Working &nbsp;<img
                            src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>
<app-share-button></app-share-button>